






















import Vue from "vue";
import { mapActions, mapState } from "vuex";
import { User, getErrorMsg } from "@/types";
import { get } from "@/api";
import { Form, CustomRenderers } from "@canvas/vuejsonschemaform";
import { JSONSchema } from "@canvas/componentlibrary/src/types";
import { arrayRenderComposite } from "../Renderers";

export default Vue.extend({
  components: {
    Form,
  },
  data(): { [key: string]: any } {
    return {
      projectDetailFormStructure: {},
      formInitialData: null,
      isProjectUpdateAllowed: false,
      saveBtn: {
        isDisabled: false,
        text: "Next",
      },
    };
  },
  computed: {
    ...mapState("appModule", {
      projectLead: "projectLead",
      partialProject: "partialProject",
      selectedEc: "selectedEc",
      countryCode: "countryCode",
    }),
    renderers() {
      const designBriefRenders = {
        arrayComposite: arrayRenderComposite,
      };
      (CustomRenderers["*"] as any) = {
        ...CustomRenderers["*"],
        ...designBriefRenders,
      };
      return CustomRenderers;
    },
  },
  methods: {
    ...mapActions("appModule", ["getFormStructureSchema"]),
    goToNextStep() {
      let resPromise: Promise<any> | undefined;
      resPromise = (this as any).handleWithDecorationAction(
        (this as any).isProjectUpdateAllowed
          ? (this as any).updateCurrentProject
          : (this as any).createNewProject,
        (this as any).saveBtn
      );
      if (resPromise) {
        //Need to check why this wasn't working and I had to add ctx here
        let ctx = this;
        resPromise
          .then((response: any) => {
            if (response) {
              ctx.$router.push({
                path:
                  "/lead/" +
                  ctx.$router.currentRoute.params.lead_id +
                  "/" +
                  ctx.partialProject.project_id +
                  "/assignment",
              });
            }
          })
          .catch((err: any) => {});
      }
    },
    ...mapActions("appModule", [
      "createProject",
      "updateProject",
      "broadcastEcLead",
      "getProjectLead",
      "getProjectDetails",
    ]),
    ...mapActions("uiModule", ["pollForDesigners"]),
    validateAndSetError(formData: any, form: any, attribute: string) {
      if (formData.attribute_data[attribute]?.length === 0) {
        // @ts-ignore
        form.formdata.statuses.attribute_data[attribute] = "error";
        return true;
      }
      return false;
    },
    createNewProject() {
      const form = (this as any).$refs.form2 as Form;
      let formdata_project = ((this as any).$refs.form2 as Form).getFormData();
      if (formdata_project) {
        const errorInKnowAboutLivspace = this.validateAndSetError(
          formdata_project,
          form,
          "know_about_livspace"
        );
        const errorInKnowAboutExperienceCenter = this.validateAndSetError(
          formdata_project,
          form,
          "know_about_experience_center"
        );

        if (errorInKnowAboutLivspace || errorInKnowAboutExperienceCenter) {
          return;
        }
        //transform  budget
        if (formdata_project.attribute_data.budget_max) {
          formdata_project.attribute_data.budget_max =
            formdata_project.attribute_data.budget_max * 100000;
          formdata_project.attribute_data.budget_min = formdata_project
            .attribute_data.budget_min
            ? formdata_project.attribute_data.budget_min * 100000
            : 0;
        }
        //  While fetching projects, projects is copied to partial projects when sets ec_visit as null
        delete formdata_project.ec_visit;
        return (this as any).createProject(
          Object.assign(formdata_project, {
            ec_id: (this as any).selectedEc.name,
          })
        );
      } else {
        return Promise.resolve();
      }
      // return Promise.resolve();
    },
    updateCurrentProject() {
      let formdata_project = ((this as any).$refs.form2 as Form).getFormData();
      if (formdata_project) {
        //transform  budget
        if (formdata_project.attribute_data.budget_max) {
          formdata_project.attribute_data.budget_max =
            formdata_project.attribute_data.budget_max * 100000;
          formdata_project.attribute_data.budget_min = formdata_project
            .attribute_data.budget_min
            ? formdata_project.attribute_data.budget_min * 100000
            : 0;
        }
        //  While fetching projects, projects is copied to partial projects when sets ec_visit as null
        delete formdata_project.ec_visit;
        return (this as any).updateProject(
          Object.assign(formdata_project, {
            ec_id: (this as any).selectedEc.name,
          }),
          (this as any).$router.currentRoute.params.project_id
        );
      } else {
        return Promise.resolve();
      }
      // return Promise.resolve();
    },
    handleWithDecorationAction(
      asyncFunc: (...args: any) => Promise<any>,
      button: { disabled: boolean }
    ) {
      button.disabled = true;
      return asyncFunc
        .apply(arguments)
        .then((response: any) => {
          button.disabled = false;
          return response;
        })
        .catch((err: any) => {
          (this as any).$store.commit("uiModule/hideLoadingModal", null, {
            root: true,
          });
          (this as any).$store.dispatch("uiModule/addToast", {
            severity: "error",
            message: getErrorMsg(err),
          });
          throw err;
        });
    },
    initProjectCreate() {
      if ((this as any).$router.currentRoute.params.lead_id) {
        //if this router got some value dispatch action to store to fetch lead and store it there.
        (this as any)
          .handleWithDecorationAction(() => {
            return (this as any).getProjectLead(
              (this as any).$router.currentRoute.params.lead_id
            );
          }, (this as any).saveBtn)
          .then(() => {
            if ((this as any).$router.currentRoute.params.project_id) {
              //get the project details
              (this as any)
                .handleWithDecorationAction(() => {
                  return (this as any).getProjectDetails(
                    (this as any).$router.currentRoute.params.project_id
                  );
                }, (this as any).saveBtn)
                .then((response: any) => {
                  (this as any).formInitialData = response;
                });
              (this as any).isProjectUpdateAllowed = true;
            }
          });
        //check if project_id is also there so as to prefetch details
      } else {
        //take user to create lead start from here
        (this as any).$router.push({ path: "/lead" });
      }
    },
  },
  mounted() {
    (this as any)
      .getFormStructureSchema("project_details")
      .then((response: any) => {
        (this as any).projectDetailFormStructure = response;
        (this as any).initProjectCreate();
      })
      .catch((err: any) => {
        throw err;
      });
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "projectslist") {
      (this as any).$store.commit("appModule/resetProjects", []);
      // next();
    }
    next();
  },
});
